import { PATHS } from "@/lib/router";
import { ManageUserPage, RolesPermissionsPage, UserListPage } from "./pages";

export const userManagementRoutes = [
  {
    path: PATHS.USER_LIST,
    element: <UserListPage />,
  },
  {
    path: `${PATHS.MANAGE_USER}/:userId`,
    element: <ManageUserPage />,
  },
  {
    path: PATHS.ROLES_PERMISSIONS,
    element: <RolesPermissionsPage />,
  },
];
